import type { BoardData, SearchHit } from '@stageplottter/core';

/** The query parameter a search hit opens a board with (OIL-236). */
export const ITEM_PARAM = 'item';

/** Hits that lead to an object on the stage: objects, notes and channels (their source). */
export function hitSelects(hit: Pick<SearchHit, 'kind' | 'id'>): boolean {
  return (hit.kind === 'item' || hit.kind === 'note' || hit.kind === 'channel') && hit.id !== '';
}

/** Where a search hit leads: the board, plus the object to select when it has one. */
export function hitHref(boardId: string, hit: Pick<SearchHit, 'kind' | 'id'>): string {
  const board = `/b/${encodeURIComponent(boardId)}`;
  return hitSelects(hit) ? `${board}?${ITEM_PARAM}=${encodeURIComponent(hit.id)}` : board;
}

/**
 * The object to select for a deep-linked id: an object or a free-form note itself, a channel's
 * source object; null while it is not (yet) on the board or has nothing to show.
 */
export function selectTarget(data: BoardData, id: string): string | null {
  if (data.items[id] !== undefined || data.freeform[id] !== undefined) return id;
  const source = data.channels[id]?.sourceItemId;
  return source !== undefined && data.items[source] !== undefined ? source : null;
}
